import {useEffect, useState} from 'react';
import DataTable from 'react-data-table-component';
import {useDispatch} from 'react-redux';
import {getXmlReports} from "../../helper/Api";
import { Chip } from '@mui/material';



export function XmlReportList({setLoading}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [schemeList, setSchemeList] = useState([])
    const dispatch = useDispatch();

    const fetch_list = async () => {
        setLoading(true);
        const schemeResponse = await getXmlReports();
        if (schemeResponse.data.status) {
            setLoading(false);
            setSchemeList(schemeResponse.data.result);
        }
    }
    useEffect(() => {
        fetch_list()
    }, [dispatch])
    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };
    const columns = [
        {
            name: 'Scheme Name',
            selector: (row) => row.name,
            sortable: true,
            width: "200px",
            wrap: true,
            right: true
        },
        {
            name: 'Scheme Code',
            selector: (row) => row.code,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'File Name',
            selector: (row) => <p className='text-secondary' onClick={() => window.open(row.file_url, "_blank", "noopener,noreferrer")}><strong>{row.filename}</strong></p>,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Ack File Name',
            selector: (row) => <p className='text-primary' onClick={() => window.open(row.ack_url, "_blank", "noopener,noreferrer")}><strong>{row.ack_filename}</strong></p>,
            sortable: true,
            width: "250px",
            wrap: true,
        },
        {
            name: 'Report Date',
            selector: (row) => row.uploaded_at,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Ack Date',
            selector: (row) => row.pulled_at,
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Status',
            selector: (row) => row.response_status === "S" ? (
                <Chip label="Success" color="success" size="small" />
            ) : (
                <Chip label="Found Error" color="error" size="small" />
            ),
            sortable: true,
            width: "200px",
            wrap: true,
        },
        {
            name: 'Errors',
            selector: (row) => '',
            sortable: true,
            width: "150px",
            wrap: true,
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    return (
        <>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={schemeList}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={schemeList.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </>

    );
}
